import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_ENDPOINTS } from '../config';
import './Login.css'; // Importar el CSS personalizado

function Login() {
  const navigate = useNavigate();
  const [documento, setDocumento] = useState('');
  const [contrasena, setContrasena] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showRecovery, setShowRecovery] = useState(false);
  const [recoveryDocumento, setRecoveryDocumento] = useState('');
  const [recoveryLoading, setRecoveryLoading] = useState(false);
  const [recoveryMessage, setRecoveryMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!documento.trim()) return setError('El documento es obligatorio.');
    if (!contrasena) return setError('La contraseña es obligatoria.');
    setLoading(true);
    try {
    const res = await fetch(API_ENDPOINTS.LOGIN, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ documento: documento.trim(), contrasena })
    });
      const data = await res.json();
      if (res.ok) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('usuario', JSON.stringify(data.socio));
        if (data.socio.administrador) {
          navigate('/admin');
        } else {
          navigate('/socio');
        }
      } else {
        setError(data.message || 'Credenciales incorrectas');
      }
    } catch (err) {
      setError('Error de red');
    }
    setLoading(false);
  };

  const handleRecoverySubmit = async (e) => {
    e.preventDefault();
    setRecoveryMessage('');
    if (!recoveryDocumento.trim()) return setRecoveryMessage('El documento es obligatorio.');
    
    setRecoveryLoading(true);
    try {
    const res = await fetch(API_ENDPOINTS.RECOVERY_PASSWORD, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ documento: recoveryDocumento.trim() })
    });
      const data = await res.json();
      if (res.ok) {
        setRecoveryMessage(data.message);
        setRecoveryDocumento('');
        // No cerrar automáticamente, esperar a que el usuario haga clic en Ok
      } else {
        setRecoveryMessage(data.message || 'Error al procesar la solicitud');
      }
    } catch (err) {
      setRecoveryMessage('Error de red');
    }
    setRecoveryLoading(false);
  };

  return (
    <div className="login-bg">
      <div className="login-overlay">
        <div className="login-card">
          <img src={process.env.PUBLIC_URL + '/escudo_miramar.png'} alt="Escudo Miramar" className="escudo-login" />
          <h2 className="login-title">Socios Club Sportivo Miramar Misiones</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Documento de Identidad</label>
              <input type="text" className="form-control" value={documento} onChange={e => setDocumento(e.target.value)} required />
            </div>
            <div className="mb-3">
              <label className="form-label">Contraseña</label>
              <input type="password" className="form-control" value={contrasena} onChange={e => setContrasena(e.target.value)} required />
            </div>
            <div className="mb-3 text-center">
              <button 
                type="button" 
                className="btn btn-link p-0 text-decoration-none" 
                onClick={() => setShowRecovery(true)}
                style={{ color: '#007bff', fontSize: '14px' }}
              >
                Crear/Recuperar Contraseña
              </button>
            </div>
            {error && <div className="alert alert-danger py-2">{error}</div>}
            <button type="submit" className="btn btn-login w-100" disabled={loading}>{loading ? 'Ingresando...' : 'Ingresar'}</button>
            <div style={{
              marginTop: '20px',
              fontSize: '0.7rem',
              color: '#666',
              textAlign: 'center',
              fontStyle: 'italic',
              lineHeight: '1.3'
            }}>
              Licenciado por Ing. Javier Barrios para uso exclusivo de Club Sportivo Miramar Misiones
            </div>
          </form>
        </div>
      </div>

      {/* Modal de Recuperación de Contraseña */}
      {showRecovery && (
        <div className="modal-overlay" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div className="modal-content" style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '10px',
            maxWidth: '400px',
            width: '90%',
            boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
          }}>
            <h4 className="text-center mb-4">Crear/Recuperar Contraseña</h4>
            <form onSubmit={handleRecoverySubmit}>
              {!recoveryMessage ? (
                <div className="mb-3">
                  <label className="form-label">Documento de Identidad (sin guión)</label>
                  <input 
                    type="text" 
                    className="form-control" 
                    value={recoveryDocumento} 
                    onChange={e => setRecoveryDocumento(e.target.value)} 
                    placeholder="Ej: 12345678"
                    required 
                  />
                </div>
              ) : null}
              {recoveryMessage && (
                <div className={`alert py-2 ${recoveryMessage.includes('exitosamente') ? 'alert-success' : 'alert-danger'}`}>
                  {recoveryMessage}
                </div>
              )}
              
              {recoveryMessage ? (
                // Mostrar solo botón Ok cuando hay cualquier mensaje (éxito o error)
                <div className="d-flex justify-content-center">
                  <button 
                    type="button" 
                    className={`btn px-4 ${recoveryMessage.includes('exitosamente') ? 'btn-success' : 'btn-danger'}`}
                    onClick={() => {
                      setShowRecovery(false);
                      setRecoveryMessage('');
                      setRecoveryDocumento('');
                    }}
                  >
                    Ok
                  </button>
                </div>
              ) : (
                // Mostrar botones Cancelar y Recuperar cuando no hay mensaje
                <div className="d-flex gap-2">
                  <button 
                    type="button" 
                    className="btn btn-secondary flex-fill" 
                    onClick={() => {
                      setShowRecovery(false);
                      setRecoveryMessage('');
                      setRecoveryDocumento('');
                    }}
                  >
                    Cancelar
                  </button>
                  <button 
                    type="submit" 
                    className="btn btn-primary flex-fill" 
                    disabled={recoveryLoading}
                  >
                    {recoveryLoading ? 'Procesando...' : 'Recuperar'}
                  </button>
                </div>
              )}
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Login; 